import Box from "@mui/material/Box";
import { Folder } from "lucide-react";

import Button from "../../Buttons/Button";
import { FAVORITES_CATEGORY } from "../../../i18n/keysTranslations";
import { COMPETITOR_FILTER_ACTIONS_SX } from "./constants";
import {
  COMPETITOR_FILTER_BUTTON_ACTIVE_SX,
  COMPETITOR_FILTER_BUTTON_SX,
} from "./constants";

const CompetitorFilterActions = ({
  t,
  showFavoritesOnly,
  onToggleShowFavoritesOnly,
}) => (
  <Box sx={COMPETITOR_FILTER_ACTIONS_SX}>
    <Button
      color="secondary"
      onClick={onToggleShowFavoritesOnly}
      ariaLabel={t(FAVORITES_CATEGORY)}
      startIcon={<Folder size={18} />}
      sx={{
        ...COMPETITOR_FILTER_BUTTON_SX,
        ...(showFavoritesOnly && COMPETITOR_FILTER_BUTTON_ACTIVE_SX),
      }}
    >
      {t(FAVORITES_CATEGORY)}
    </Button>
  </Box>
);

export default CompetitorFilterActions;
